import {parseInt, isEmpty} from 'lodash';
import safeParse from './utilites/parse.js';
gsap.registerPlugin(ScrollTrigger);

if( window.TrazanLeni ) {
    window.TrazanLeni.on('scroll', () => {
        ScrollTrigger.update()
    });
    gsap.ticker.add((time) => {
        window.TrazanLeni.raf(time * 1000);
    });
    gsap.ticker.lagSmoothing(0)
}

export default function animate() {
    document.querySelectorAll('.trazan-animate').forEach((element) => {
        const from  = safeParse(element.dataset.from);
        const to    = safeParse(element.dataset.to);
        const delay = parseFloat(element.dataset.delay) || 0;
        const idle = safeParse(element.dataset.idleAnime);
        const target = element.querySelector('img') || element;
        const idleStarted = new WeakSet();

        if (!target || !(target instanceof Element)) return;

        gsap.set(target, from);

        function addIdleLoop() {
            if (idleStarted.has(target)) return;
            idleStarted.add(target);

            gsap.to(target, {
                y: '+=' + idle.y,
                x: '+=' + idle.x,
                duration: idle.duration,
                ease: "sine.inOut",
                repeat: -1,
                yoyo: true
            });
        }

        if (idle?.enabled === 'yes') {
            const targetTo = { ...to, delay };

            targetTo.onComplete = () => addIdleLoop();

            gsap.to(target, targetTo);
        } else {
            gsap.to(target, {
                ...to,
                delay,
                scrollTrigger: {
                    trigger: element,
                    start: "top 80%",
                    end: "bottom "+to.speed,
                    ease: "power2",
                    scrub: true,
                    markers: false,
                    onLeave: () => { if (idle?.enabled === 'yes') addIdleLoop(); },
                    onEnterBack: () => { if (idle?.enabled === 'yes') addIdleLoop(); }
                }
            });
        }
    });
}



export function tzAnimeInit(scope = document) {
    const elements = scope.querySelectorAll('[data-tz-anime]');

    elements.forEach(el => {

        const type  = el.dataset.tzAnime;
        const delay = parseInt(el.dataset.tzAnimeDelay, 10) || 0;
        if( type === 'none' ) {
            return;
        }
        gsap.killTweensOf(el);
        let start = el.dataset.tzAnimeStart || "85%";
        let position = el.dataset.tzAnimePosition || 'top';
        switch (type) {
            case "fade-in":
                gsap.from(el, {
                    opacity: 0,
                    y: 10,
                    duration: 0.4,
                    delay: delay / 1000,
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: el,
                        start: position+' ' + start,
                        toggleActions: "play none none none"
                    }
                });
                break;

            case "slide-up":
                gsap.from(el, {
                    y: 100,
                    opacity: 0,
                    duration: 0.4,
                    delay: delay / 1000,
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: el,
                        start: position+' ' + start,
                        toggleActions: "play none none none"
                    }
                });
                break;

            case "zoom-in":
                gsap.from(el, {
                    scale: 0.8,
                    opacity: 0,
                    duration: 0.4,
                    delay: delay / 1000,
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: el,
                        start: position+' ' + start,
                        toggleActions: "play none none none"
                    }
                });
                break;

            default:
                break;
        }
    });
}
